/**
 * Styles CSS pour le composant `react-phone-number-input`.
 *
 * La librairie expose des classes globales (`.PhoneInput`, `.PhoneInputCountry`,
 * `.PhoneInputInput`, ...) qu'on aligne sur le style des autres champs de
 * formulaire ServUp (border `#d1d5db`, radius 8px, focus bleu `#3b82f6`).
 *
 * Injection : `<style>{phoneInputStyles}</style>` une fois par page qui
 * affiche un PhoneInput.
 */
export const phoneInputStyles = `
  .PhoneInput {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .PhoneInputCountry {
    display: flex;
    align-items: center;
    padding: 12px;
    background: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    cursor: pointer;
  }
  .PhoneInputCountryIcon {
    width: 24px;
    height: 18px;
    border-radius: 2px;
    overflow: hidden;
  }
  .PhoneInputCountryIconImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .PhoneInputCountrySelectArrow {
    margin-left: 6px;
    border-style: solid;
    border-color: #6b7280 transparent transparent;
    border-width: 5px 4px 0;
  }
  .PhoneInputInput {
    flex: 1;
    padding: 12px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.15s;
  }
  .PhoneInputInput:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
`;
